import { TextKey } from '@mews-commander/enums';
import MailType from './MailType';
import ResendEmailReceiver from './ResendEmailReceiver';

export const mailTypeTextKeyMap: Record<MailType, Mews.TextKey> = {
    [MailType.BeforeStart]: TextKey.MailTemplateTypeBeforeStart,
    [MailType.Quotation]: TextKey.MailTemplateTypeQuotation,
    [MailType.ReleaseReminder]: TextKey.MailTypeReleaseReminder,
    [MailType.Confirmation]: TextKey.MailTemplateTypeConfirmation,
    [MailType.BookerConfirmation]: TextKey.BookerConfirmation,
    [MailType.Cancellation]: TextKey.MailTemplateTypeCancellation,
    [MailType.AfterStart]: TextKey.MailTemplateTypeAfterStart,
    [MailType.AfterEnd]: TextKey.MailTemplateTypeAfterEnd,
    [MailType.NotSelected]: TextKey.NotSelected,
};

export const resendEmailReceiverTextKeyMap: Record<ResendEmailReceiver, Mews.TextKey> = {
    [ResendEmailReceiver.Customer]: TextKey.ReceiverTypeCustomer,
    [ResendEmailReceiver.Booker]: TextKey.ReceiverTypeBooker,
    [ResendEmailReceiver.Custom]: TextKey.ReceiverTypeCustom,
    [ResendEmailReceiver.NotSelected]: TextKey.NotSelected,
};
